export async function fetchMaxMindGeolocation(): Promise<any> {
  const res = await fetch('/api/maxmindgeolocation', {
    method: 'GET',
  });

  if (res.status !== 200) {
    throw new Error(`Error fetching maxmind geolocation: ${res.status} ${res.url} ${res.text()}`);
  }

  return res.json();
}
